export const ROLES: any[] = [
  { label: "Admin", value: "admin" },
  { label: "Basic", value: "basic" },
  { label: "Beta user", value: "beta user" },
];

export const STATUS = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const KEY_ACCOUNTS = [
  {
    id: "0edc4b5b-8efc-48c8-a926-7ba87c5a52e5",
    country: "USA",
    created_by: "bf0570be-6bc9-49f8-9717-9a9e69eb11b6",
    created_at: "2023-04-18T07:00:08.377000",
    region: "Brazil",
    name: "711",
    zone_id: "d497d1dd-f132-4349-9122-982c54da6c03",
    updated_by: "bf0570be-6bc9-49f8-9717-9a9e69eb11b6",
    updated_at: "2023-04-18T07:18:49.793000",
  },
  {
    id: "61452125-97e8-44f5-82e3-2ffc2c4cab0d",
    country: "Canada",
    created_by: "bf0570be-6bc9-49f8-9717-9a9e69eb11b6",
    created_at: "2023-04-18T07:00:08.377000",
    region: "Canada",
    name: "ClubElite",
    zone_id: "d497d1dd-f132-4349-9122-982c54da6c03",
    updated_by: "bf0570be-6bc9-49f8-9717-9a9e69eb11b6",
    updated_at: "2023-04-18T07:15:05.390000",
  },
  {
    id: "cdd3164f-86e9-4ff4-8e9b-e1efcf740d56",
    country: "Canada",
    created_by: "bf0570be-6bc9-49f8-9717-9a9e69eb11b6",
    created_at: "2023-04-18T07:00:08.377000",
    region: "East",
    name: "ClubElite",
    zone_id: "d497d1dd-f132-4349-9122-982c54da6c03",
    updated_by: "bf0570be-6bc9-49f8-9717-9a9e69eb11b6",
    updated_at: "2023-04-18T07:15:28.403000",
  },
  {
    id: "202a321d-9fe3-4da7-aac3-9dc1f932beba",
    country: "USA",
    created_by: "bf0570be-6bc9-49f8-9717-9a9e69eb11b6",
    created_at: "2023-04-18T07:00:08.377000",
    region: "Brazil",
    name: "Condor",
    zone_id: "d497d1dd-f132-4349-9122-982c54da6c03",
    updated_by: "bf0570be-6bc9-49f8-9717-9a9e69eb11b6",
    updated_at: "2023-04-18T07:17:48.620000",
  },
];

export const CAN_VIEW_OPTIONS = [
  { label: "View", value: "View", inactive: true },
  { label: "Edit", value: "Edit" },
  { label: "Remove", value: "Remove" },
];
